import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import { interviewNumbering, learningAjahnNumbering } from '../../utils/constant';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import { interviewFormValidationSchema } from '../../utils/formValidation';
import { postInterviewForm } from '../../services/interview';
import { errorToast } from '../../utils/errorHandling';
import { toast } from 'react-toastify';
import useFormValidation from '../../hooks/useFormValidation';
import { AiOutlineLoading } from 'react-icons/ai';
import { actionTypes, useApp, useAppDispatch } from '../../features/AppContext';

const base_url = process.env.REACT_APP_BASE_URL;

const CreateInterview = () => {
    const { t } = useTranslation();
    const { interviewAjahnsList, learningAjahnsList, user_id, retreat_language, formcheck } = useApp();
    const dispatch = useAppDispatch();
    const [selectedAjahn, setSelectedAjahn] = useState(Array(interviewNumbering(t).length).fill(""));
    const [selectedLearningAjahn, setSelectedLearningAjahn] = useState(Array(learningAjahnNumbering(t).length).fill(""));
    const [formSection, setFormSection] = useState(1);
    const [formPercentage, setFormPercentage] = useState("33%");
    const [formData, setFormData] = useState({});
    const [formValidationSchema, setFormValidationSchema] = useState([]);
    const [role, setRole] = useState(null);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(interviewFormValidationSchema(t));
    const navigate = useNavigate();
    const errorFields = [
        "first_choice",
        "second_choice",
        "third_choice",
        "fourth_choice",
        "fifth_choice",
        "sixth_choice",
        "seventh_choice",
        "eighth_choice",
        "ninth_choice",
        "tenth_choice"
    ];
    const navigateFormSection = (forward) => {
        if (formSection === 2 && forward) {
            if (validateAllFields(formData, formValidationSchema)) {
                const section = forward ? formSection + 1 : formSection - 1;
                setFormSection(section);
                const percentage = (section / 3) * 100;
                const percentageString = percentage + "%";
                setFormPercentage(percentageString);
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                toast.error(t("general.ValidationFail"));
            }
        } else {
            const section = forward ? formSection + 1 : formSection - 1;
            setFormSection(section);
            const percentage = (section / 3) * 100;
            const percentageString = percentage + "%";
            setFormPercentage(percentageString)
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [formSection]);

    useEffect(() => {
        setFormData({
            is_interview: "",
            first_choice: "",
            second_choice: "",
            third_choice: "",
            fourth_choice: "",
            fifth_choice: "",
            sixth_choice: "",
            seventh_choice: "",
            eighth_choice: "",
            ninth_choice: "",
            tenth_choice: "",
            first_choice_learning: "",
            second_choice_learning: "",
            third_choice_learning: "",
            fourth_choice_learning: "",
            fifth_choice_learning: "",
        })
        setFormValidationSchema([
            "is_interview",
        ]);
        setRole(retreat_language ? retreat_language : "Chinese");
    }, [])

    const handleAjahnSelectionChange = (index, event) => {
        const { id, value } = event.target;
        const newSelectedAjahn = [...selectedAjahn];
        newSelectedAjahn[index] = value;
        setSelectedAjahn(newSelectedAjahn);
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value);
    };
    const getAvailableAjahnOptions = (currentIndex) => {
        const alreadySelected = selectedAjahn.filter((_, idx) => idx !== currentIndex);
        return interviewAjahnsList.filter(option => !alreadySelected.includes(option.ajahn_ename));
    };

    const handleAjahnLearningSelectionChange = (index, event) => {
        const { id, value } = event.target;
        const newSelectedLearningAjahn = [...selectedLearningAjahn];
        newSelectedLearningAjahn[index] = value;
        setSelectedLearningAjahn(newSelectedLearningAjahn);
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value);
    };
    const getAvailableLearningAjahnOptions = (currentIndex) => {
        const alreadySelected = selectedLearningAjahn.filter((_, idx) => idx !== currentIndex);
        return learningAjahnsList.filter(option => !alreadySelected.includes(option.ajahn_ename));
    };

    const handleInputChange = (e) => {
        const { id, name } = e.target;
        if (name === "is_interview") {
            setFormData((prevState) => ({
                ...prevState,
                [name]: id,
            }));
            if (role === "Chinese" && id === "1") {
                setFormValidationSchema([
                    "is_interview",
                    "first_choice",
                    "second_choice",
                    "third_choice",
                    "fourth_choice",
                    "fifth_choice",
                    "sixth_choice",
                    "seventh_choice",
                    "eighth_choice",
                    "ninth_choice",
                    "tenth_choice",
                    "first_choice_learning",
                    "second_choice_learning",
                    "third_choice_learning",
                    "fourth_choice_learning",
                    "fifth_choice_learning",
                ]);
            } else if (role === "Chinese" && id === "0") {
                setFormValidationSchema([
                    "is_interview",
                    "first_choice_learning",
                    "second_choice_learning",
                    "third_choice_learning",
                    "fourth_choice_learning",
                    "fifth_choice_learning",
                ]);
            } else if (role === "English" && id === "1") {
                setFormValidationSchema([
                    "is_interview",
                    "first_choice",
                    "second_choice",
                    "third_choice",
                    "fourth_choice",
                    "fifth_choice",
                    "sixth_choice",
                    "seventh_choice",
                    "eighth_choice",
                    "ninth_choice",
                    "tenth_choice",
                ]);
            } else if (role === "English" && id === "0") {
                setFormValidationSchema([
                    "is_interview"
                ]);
            }
            validateField(name, id);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const submitInterviewForm = async () => {
            try {
                const data = await postInterviewForm(user_id, formData);
                if (data) {
                    const formCheckData = {
                        ...formcheck,
                        is_interview_filled: '1'
                    };
                    dispatch({
                        type: actionTypes.UPDATE_FORMCHECK,
                        payload: formCheckData
                    });
                    toast.success(t("interview.InterviewSuccess"));
                    navigate(`${base_url}/view-interview`);
                }
            } catch (error) {
                errorToast(error, t("Passport.SubmitedFailed"), t);
            } finally {
                setIsSubmitting(false);
            }
        }
        setIsSubmitting(true);
        if (validateAllFields(formData, formValidationSchema)) {
            submitInterviewForm();
        } else {
            toast.error(t("personal_info.ValidateFailedfield"));
            setIsSubmitting(false);
        }
    }
    return (
        <>
            <div className='info-container'>
                <h3>{t("interview.BigTitle")}</h3>
                <p>{t("interview.smallTitle")}</p>
                <div className='action-buttons'>
                    <Link to={`${base_url}/view-interview`}>
                        <Button
                            buttonStyle='btn--primary'
                            buttonSize='btn--small'
                        >{t("ctransportation.cancel")}</Button>
                    </Link>
                </div>
            </div>
            <div className='form-wrapper'>
                <h4 className='d-flex mt-3 justify-content-left'>{t("general.Page")} {formSection} {t("general.OF3")}</h4>
                <div className="progress mb-5">
                    <div className="progress-bar bg-success" role="progressbar" style={{ "width": formPercentage }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <form>
                    <div className='form-section-1' hidden={formSection !== 1}>
                        <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.NOTICE")}</strong></span></p>
                        <ul>
                            <li>{t("interview.N1")}</li>
                            <li>{t("interview.N2")}</li>
                        </ul>
                        <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.studentNO")}</strong></span></p>
                        <ol>
                            <li>{t("interview.SN1")}</li>
                            <li>{t("interview.SN2")}</li>
                            <li>{t("interview.SN3")}</li>
                            <li>{t("interview.SN4")} <br />
                                {t("interview.SN5")}</li>
                            <li>{t("interview.SN6")}</li>
                        </ol>
                        <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.NonInt_STU")}</strong></span></p>
                        <ol>
                            <li>{t("interview.NIS_1")}</li>
                            <li>{t("interview.NIS_2")}</li>
                            <li>{t("interview.NIS_4")} <br />
                                {t("interview.NIS_5")}</li>
                        </ol>
                        <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.Stu_Req_Eng")}</strong></span></p>
                        <ol>
                            <li>{t("interview.SRE1")}</li>
                            <li>{t("interview.SRE2")}</li>
                        </ol>
                        <p>
                            <span style={{ "color": "#ff0000" }}>{t("interview.SRE3")}</span>
                        </p>

                    </div>
                    <div className='form-section-2' hidden={formSection !== 2}>
                        <div className='section-title'>
                            <h4 className='mb-0'>{t("interview.Int_INFO")}</h4>
                        </div>
                        <p className='mt-3'><strong>{t("interview.desOPT")}</strong></p>
                        <ul className='mb-0'>
                            <li>{t("interview.FC1")}</li>
                            <li>{t("interview.FC2")}</li>
                            <li>{t("interview.FC3")}</li>
                            <li>{t("interview.FC4")}</li>
                            <li>{t("interview.FC5")}</li>
                        </ul>
                        <p><span style={{ "color": "#ff0000" }}>{t("interview.fc")}</span></p>
                        <p className='mt-3'><strong>{t("interview.Int_QUO")}</strong></p>
                        <ol>
                            {interviewAjahnsList.map((i, index) => (
                                <li key={index}>
                                    {localStorage.getItem("i18nextLng") === 'en' ? i.ajahn_ename : i.ajahn_cname}
                                    &nbsp;:&nbsp;
                                    <span style={{ "fontStyle": "italic" }}>{i.interview_pax} {t("Constant.PAX")}</span>
                                </li>
                            ))}
                        </ol>
                        {role === "Chinese" &&
                            <>
                                <label>{t("interview.selectLearningAjahn")}</label>
                                {errors && Object.entries(errors).map(([key, error]) => {
                                    if (key !== "is_interview" && error !== "" && !errorFields.includes(key)) {
                                        return <p className='m-0'><span key={key} className="error">{error}</span></p>;
                                    }
                                })}
                                <table className="table table-light" style={{ "fontSize": "13px", maxWidth: "800px" }}>
                                    <thead>
                                        <tr>
                                            <th scope="col">{t("interview.choice")}</th>
                                            <th scope="col">{t("interview.learningAjahn")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {learningAjahnNumbering(t).map((i, index) => (
                                            <tr key={index}>
                                                <td>{i.displayNumbering}</td>
                                                <td>
                                                    <select
                                                        id={i.key}
                                                        value={selectedLearningAjahn[index] || ""}
                                                        onChange={(e) => handleAjahnLearningSelectionChange(index, e)}
                                                    >
                                                        <option value="">{t("interview.s2")}</option>
                                                        {getAvailableLearningAjahnOptions(index).map((option, idx) => (
                                                            <option key={idx} value={option.ajahn_ename}>
                                                                {localStorage.getItem("i18nextLng") === 'en' ? option.ajahn_ename : option.ajahn_cname}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                        ))
                                        }

                                    </tbody>
                                </table>
                            </>
                        }
                        <div className="form-item">
                            <label>{t("interview.q1")}
                                <span style={{ "color": "#ff0000" }}>{t("interview.interviewNonEditable")}</span></label>
                            <div className='radio'>
                                <input className="form-check-input" type="radio" name="is_interview" id="1" required
                                    onChange={handleInputChange} />
                                <p className='radioLabel mb-0'>{t("general.yes")}</p>
                            </div>
                            <div className='radio'>
                                <input className="form-check-input" type="radio" name="is_interview" id="0" required
                                    onChange={handleInputChange} />
                                <p className='radioLabel mb-0'>{t("general.no")}</p>
                            </div>
                        </div>
                        {errors.is_interview && <span className="error">{errors.is_interview}</span>}
                        {formData.is_interview === "1" && (
                            <>
                                <label>{t("interview.selectInterviewAjahn")}</label>
                                {errors && Object.entries(errors).map(([key, error]) => {
                                    if (key !== "is_interview" && error !== "" && errorFields.includes(key)) {
                                        return <p className='m-0'><span key={key} className="error">{error}</span></p>;
                                    }
                                })}
                                <div>
                                    <table className="table table-light" style={{ "fontSize": "13px", "maxWidth": "800px" }}>
                                        <thead>
                                            <tr>
                                                <th scope="col">{t("interview.choice")}</th>
                                                <th scope="col">{t("interview.interviewAjahn")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {interviewNumbering(t).map((i, index) => (
                                                <tr key={index}>
                                                    <td>{i.displayNumbering}</td>
                                                    <td>
                                                        <select
                                                            id={i.key}
                                                            value={selectedAjahn[index] || ""}
                                                            onChange={(e) => handleAjahnSelectionChange(index, e)}
                                                        >
                                                            <option value="">{t("interview.s2")}</option>
                                                            {getAvailableAjahnOptions(index).map((option, idx) => (
                                                                <option key={idx} value={option.ajahn_ename}>
                                                                    {localStorage.getItem("i18nextLng") === 'en' ? option.ajahn_ename : option.ajahn_cname}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </tr>
                                            ))
                                            }
                                        </tbody>
                                    </table>
                                </div>

                            </>
                        )}
                    </div>
                    <div className='form-section-3' hidden={formSection !== 3}>
                        <div className='section-description pt-2 pb-3'>
                            <p>
                                {t("general.tq")}
                                <span style={{ "color": "#ff0000" }}><strong>{t("general.submit")}</strong></span>
                            </p>
                            <Trans key="accomodation" html="br:<br/>">
                                {t("general.Declaration1")}
                            </Trans>
                            <p>
                                <strong>{t("general.contact_Info")}</strong>
                                <Trans key="general" html="br:<br/>">
                                    {t("general.infoContent")}
                                    <a href="mailto:retreat@shineling.org">{t("general.retreatEmail")}</a>
                                </Trans>
                                <br />
                                <Link to="https://www.shineling.org:3004" target="_blank" rel="noopener noreferrer">
                                    {t("general.retreatChatbot")}
                                </Link>
                            </p>
                            <p>
                                -----------------------------
                                <Trans key="general" html="br/:<br />">
                                    <br />{t("general.snl")}
                                </Trans>
                            </p>
                        </div>
                    </div>
                    <div className='button-container mt-3'>
                        <Button buttonStyle="btn--primary" hidden={formSection === 1} type="button" onClick={() => navigateFormSection(false)}>{t("general.BTNprevious")}</Button>
                        <Button buttonStyle="btn--primary" hidden={formSection === 3} type="button" onClick={() => navigateFormSection(true)}>{t("general.BTNnext")}</Button>
                        <Button buttonStyle="btn--primary" hidden={formSection !== 3} onClick={handleSubmit} disabled={isSubmitting}>
                            {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                        </Button>
                    </div>

                </form>
            </div>
        </>
    )
}

export default CreateInterview